import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../../../Components/Navbar/navbar";
import styles from "../../../Styles/edit.module.css";
import { HiPlus, HiSearch, HiX, HiXCircle } from "react-icons/hi";
import { useLocation, useNavigate, useParams } from "react-router";
import axios from "axios";
import { getUser, Url } from "../../../../Constants/globals";
import RefreshToken from "../../../../Components/RefreshToken/RefreshToken";
import Dropdown from "../../../../Components/Dropdown/dropdown";
import GoBack from "../../../../Components/GoBack/goback";
import stylesModal from "../../../../Components/DeleteModal/deletemodal.module.css";
import Loading from "../../../../Components/Loading/loading";
import Alert from "../../../../Components/Alert/alert";
import { ChromePicker } from 'react-color'

async function addNewInfo(companyId, type, value, customHandle) {
    if (!customHandle) return ["", <Alert type={"error"}>{`Indique o nome do campo`}</Alert>];
    if (!value) return ["", <Alert type={"error"}>{`Indique o valor do campo ${customHandle}`}</Alert>];
    try {
        const response = await axios.post(`${Url}/companies/${companyId}/links`,
            {
                label: customHandle,
                platform: type.handle,
                url: value
            }, {
            headers: {
                Authorization: "Bearer " + getUser().token,
            },
        });
        return [response.data, <Alert type={"success"}>Informação adicionada com sucesso!</Alert>];
    }
    catch (err) {
        if (err.request && err.request.status === 401) {
            var newToken = await RefreshToken(err);
            if (newToken) return await addNewInfo(companyId, type, value, customHandle);
            else window.location.reload();
        }
        else {
            console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a informação");
            return ["", <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a informação"}</Alert>];
        }
    };
}

async function deleteNewInfo(id){
    try {
        await axios.delete(`${Url}/company-links/${id}`, {
            headers: {
                Authorization: "Bearer " + getUser().token,
            },
        });
        return [200, <Alert type={"success"}>Informação eliminada com sucesso!</Alert>];
    }
    catch (err) {
        if (err.request && err.request.status === 401){
            var newToken = await RefreshToken(err);
            if (newToken) return await deleteNewInfo(id);
            else window.location.reload();
        }
        else {
            console.error(err);
            return  [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar a informação"}</Alert>];
        }
    };
}

async function addCompany(nome, logo, cor1, cor2, cor3) {
    const formData = new FormData();

    formData.append("name", nome);
    if (logo) formData.append("logo", logo);

    const themeConfig = {
        "primary_color": cor1,
        "secondary_color": cor2,
        "third_color": cor3
    }
    formData.append("theme_config", JSON.stringify(themeConfig));

    try {
        const res = await axios.post(`${Url}/business-companies`, formData, {
            headers: {
                Authorization: "Bearer " + getUser().token,
            },
        });
        return [res.data, <Alert type={"success"}>Empresa adicionada com sucesso!</Alert>];
    }
    catch (err) {
        if (err.request && err.request.status === 401){
            var newToken = await RefreshToken(err);
            if (newToken) return await addCompany(nome, logo, cor1, cor2, cor3);
            else window.location.reload();
        }
        else {
            console.error(err);
            return  [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a empresa"}</Alert>];
        }
    };
}

async function editCompany(id, nome, logo, cor1, cor2, cor3) {
    const formData = new FormData();

    formData.append("name", nome);
    if (logo) formData.append("logo", logo);

    const themeConfig = {
        "primary_color": cor1,
        "secondary_color": cor2,
        "third_color": cor3
    }
    formData.append("theme_config", JSON.stringify(themeConfig));

    try {
        await axios.patch(`${Url}/business-companies/${id}`, formData, {
            headers: {
                Authorization: "Bearer " + getUser().token,
            },
        });
        return [200, <Alert type={"success"}>Empresa editada com sucesso!</Alert>];
    }
    catch (err) {
        if (err.request && err.request.status === 401){
            var newToken = await RefreshToken(err);
            if (newToken) return await editCompany(id, nome, logo, cor1, cor2, cor3);
            else window.location.reload();
        }
        else {
            console.error(err);
            return  [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar a empresa"}</Alert>];
        }
    };
}

function EditarEmpresasCartoes({ userPermissions }) {

    const location = useLocation();
    const { state } = location;
    const navigate = useNavigate();
    const {id} = useParams();
    const newInfoRef = useRef();

    const [alert, setAlert] = useState("");
    const [loading, setLoading] = useState("");
    const [loadingData, setLoadingData] = useState(true);

    const [foregroundColor, setForegroundColor] = useState("#000000");
    const [backgroundColor, setBackgroundColor] = useState("#000000");
    const [textColor, setTextColor] = useState("#000000");

    const [nome, setNome] = useState("");
    const [logo, setLogo] = useState(null);

    const [newIndexValue, setNewIndexValue] = useState("");
    
    const [newInfoHandle, setNewInfoHandle] = useState("");
    const [newInfo, setNewInfo] = useState("");
    const infoTypes = [
        {
            id: 1,
            name: "Email",
            handle: "email"
        },
        {
            id: 2,
            name: "WhatsApp",
            handle: "whatsapp",
            default: "+351"
        },
        {
            id: 3,
            name: "Instagram",
            handle: "instagram",
            default: "www.instagram.com/"
        },
        {
            id: 4,
            name: "Facebook",
            handle: "facebook",
            default: "www.facebook.com/"
        },
        {
            id: 5,
            name: "LinkedIn",
            handle: "linkedin",
            default: "www.linkedin.com/company/"
        },
        {
            id: 6,
            name: "Website",
            handle: "website",
            default: "www."
        },
        {
            id: 7,
            name: "Contacto",
            handle: "mobile",
            default: "+351"
        },
        {
            id: 8,
            name: "Morada",
            handle: "address"
        },
        {
            id: 9,
            name: "TikTok",
            handle: "tiktok",
            default: "www.tiktok.com/"
        },
        {
            id: 10,
            name: "YouTube",
            handle: "youtube",
            default: "www.youtube.com/"
        },
    ];
    const [selectedInfoType, setSelectedInfoType] = useState("");

    const [info, setInfo] = useState([]);
    
    async function fetchDetails() {
        try {
            const res = await axios.get(`${Url}/business-companies/${id}`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return res.data;
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await fetchDetails();
                else window.location.reload();
            }
            else {
                console.error(err);
                return "";
            }
        };
    }
    
    async function fetchCompanyLinks() {
        try {
            const res = await axios.get(`${Url}/companies/${id}/links`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return res.data;
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await fetchCompanyLinks();
                else window.location.reload();
            }
            else {
                console.error(err);
                return [];
            }
        };
    }

    async function assignData() {
        if (id) {
            const results = await Promise.all([fetchDetails(), fetchCompanyLinks()]);
            const [detailsData, companyLinks] = results;
            setInfo(companyLinks?.length ? companyLinks : []);
            if (detailsData) {
                setNome(detailsData.name);
                if (detailsData.logo_url) setLogo(detailsData.logo_url);
                setForegroundColor(detailsData.theme_config.primary_color);
                setBackgroundColor(detailsData.theme_config.secondary_color);
                setTextColor(detailsData.theme_config.third_color);
            }
            else navigate("/empresas-cartoes");
        }
        setLoadingData(false);
    }

    useEffect(() => {
        assignData();
    }, []);

    async function getAlertAdd() {
        if (!nome || !logo || !foregroundColor || !backgroundColor || !textColor) return setAlert(<Alert type={"error"}>Os campos do nome, logo e das cores são obrigatórios</Alert>);
        await setLoading(<Loading />);
        await setAlert("");
        const res = await addCompany(nome, logo, foregroundColor, backgroundColor, textColor);
        setLoading("");
        if (res[0]) window.location = `/empresas-cartoes/${res[0].id}`;
        else setAlert(res[1]);
    }

    async function getAlertEdit() {
        if (!nome || !logo || !foregroundColor || !backgroundColor || !textColor) return setAlert(<Alert type={"error"}>Os campos do nome, logo e das cores são obrigatórios</Alert>);
        await setLoading(<Loading />);
        await setAlert("");
        const res = await editCompany(id, nome, typeof logo === "string" ? "" : logo, foregroundColor, backgroundColor, textColor);
        setLoading("");
        setAlert(res[1]);
    }

    async function getAlertAddInfo() {
        await setAlert("");
        const res = await addNewInfo(id, selectedInfoType, newInfo, newInfoHandle);
        setAlert(res[1]);
        const companyLinks = await fetchCompanyLinks();
        setInfo(companyLinks?.length ? companyLinks : []);
    }

    async function getAlertDelete(infoId) {
        await setAlert("");
        const res = await deleteNewInfo(infoId);
        setAlert(res[1]);
        const companyLinks = await fetchCompanyLinks();
        setInfo(companyLinks?.length ? companyLinks : []);
    }

    useEffect(() => {
        setNewInfoHandle(selectedInfoType.name ? selectedInfoType.name : "");
        setNewInfo(selectedInfoType.default ? selectedInfoType.default : "");
        if (newInfoRef?.current) newInfoRef.current.focus();
    }, [selectedInfoType]);

    async function changeFieldPosition(link_id) {
        if (newIndexValue) {
            try {
                await axios.patch(`${Url}/company-links/${link_id}/position`,
                    {
                        new_position: newIndexValue
                    }, {
                    headers: {
                        Authorization: "Bearer " + getUser().token,
                    },
                });
                setNewIndexValue("");
                const companyLinks = await fetchCompanyLinks();
                setInfo(companyLinks?.length ? companyLinks : []);
                return;
            }
            catch (err) {
                if (err.request && err.request.status === 401) {
                    var newToken = await RefreshToken(err);
                    if (newToken) return await changeFieldPosition(link_id);
                    else window.location.reload();
                }
                else {
                    console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao alterar a ordenação dos campos");
                    return;
                }
            };
        }
    }

    return (
        <div className="body">
            {alert}
            {loading}
            <NavBar current={"empresas"} setDisappear={setLoadingData} userPermissions={userPermissions} />
            {
                loadingData ? ""
                    :
                    <div className={styles.content}>
                        <GoBack backRoute={`/empresas-cartoes`} backState={state?.page ? { page: state.page, nomeSearch: state.nomeSearch ?? "" } : {}} />
                        <h1 className={styles.backgroundName}>
                            {
                                id ? "Editar empresa" : "Adicionar empresa"
                            }
                        </h1>
                        <div className={styles.formBlock}>
                            <div className={styles.formBlockSection}>
                                <p>
                                    Nome:
                                </p>
                                <input
                                    type="text"
                                    value={nome}
                                    onChange={(e) => setNome(e.target.value)}
                                />
                            </div>
                            <div className={styles.formBlockSection}>
                                <p style={{display: "flex", gap: "8px"}}>
                                    {
                                        typeof logo === "string" ?
                                            <HiXCircle color="var(--buttonBackground)" style={{cursor: "pointer"}} size={18} onClick={() => setLogo(null)} />
                                        :""
                                    }
                                    Logo:
                                </p>
                                {
                                    typeof logo === "string" ?
                                        <img src={`${Url}/${logo}`} className={styles.companyLogo} alt="" />
                                    :
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => setLogo(e.target.files[0])}
                                        />
                                }
                            </div>
                            <div style={{gridColumnStart: 1, gridColumnEnd: 4}}>
                                <div className={styles.formBlockSection} style={{display: "flex", justifyContent: "center", gap: "60px", flexWrap: "wrap", backgroundColor: "transparent", padding: 0}}>
                                    <div>
                                        <div style={{backgroundColor: foregroundColor}} className={styles.firstColor} />
                                        <p>Cor primária:</p>
                                        <ChromePicker
                                            disableAlpha
                                            color={foregroundColor}
                                            onChange={(color) => setForegroundColor(color.hex)}
                                        />
                                    </div>
                                    <div>
                                        <div style={{backgroundColor: backgroundColor}} className={styles.secondColor} />
                                        <p>Cor secundária:</p>
                                        <ChromePicker
                                            disableAlpha
                                            color={backgroundColor}
                                            onChange={(color) => setBackgroundColor(color.hex)}
                                        />
                                    </div>
                                    <div>
                                        <div style={{color: textColor}}>Texto</div>
                                        <p>Cor do texto:</p>
                                        <ChromePicker
                                            disableAlpha
                                            color={textColor}
                                            onChange={(color) => setTextColor(color.hex)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            id ?
                                <>
                                    <h3 style={{textAlign: "center", marginTop: "2rem"}}>Informações</h3>
                                    {
                                        info?.length ?
                                            <div style={{marginBottom: "1rem"}} className={styles.formBlock}>
                                                {
                                                    info.map((i, index) =>
                                                        <div key={index} className={styles.formBlockSection}>
                                                            <input
                                                                type="number"
                                                                placeholder={`${index}`}
                                                                style={{ width: "40px", paddingRight: 0, backgroundColor: "var(--background)" }}
                                                                min={0}
                                                                max={info.length - 1}
                                                                onChange={(e) => setNewIndexValue(e.target.value)}
                                                                onKeyDown={(e) => e.key === "Enter" && changeFieldPosition(i.id)}
                                                            />
                                                            <p>
                                                                {i.label ? i.label : i.platform === "mobile" ? "Contacto" : i.platform === "address" ? "Morada" : i.platform}:
                                                            </p>
                                                            <input disabled type="text" value={i.url} />
                                                            <HiX style={{marginRight: "8px", cursor: "pointer"}} color="red" onClick={() => getAlertDelete(i.id)} />
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        : ""
                                    }
                                    <h3 style={{textAlign: "center"}}>Adicionar</h3>
                                    <div className={styles.formBlock}>
                                        <Dropdown
                                            label={"Tipo:"}
                                            placeholder={"Escolher tipo de informação"}
                                            items={infoTypes}
                                            value={selectedInfoType}
                                            onValueChange={setSelectedInfoType}
                                        />
                                        {
                                            selectedInfoType ?
                                                <div className={styles.formBlockSection}>
                                                    <input
                                                        style={{backgroundColor: "var(--background)", width: "200px"}}
                                                        type="text"
                                                        placeholder="Nome do campo"
                                                        value={newInfoHandle}
                                                        onChange={(e) => setNewInfoHandle(e.target.value)}
                                                    />
                                                    <input
                                                        ref={newInfoRef}
                                                        type="text"
                                                        autoFocus={selectedInfoType}
                                                        value={newInfo}
                                                        onChange={(e) => setNewInfo(e.target.value)}
                                                    />
                                                    <button
                                                        className={styles.btnFileType}
                                                        style={{width: "160px", marginRight: "8px", backgroundColor: "var(--hoverItem)"}}
                                                        onClick={() => getAlertAddInfo()}
                                                    >
                                                        Adicionar
                                                    </button>
                                                </div>
                                            :
                                                <div></div>
                                        }
                                    </div>
                                </>
                            :""
                        }
                        {
                            id ?
                                <button className={styles.btn} onClick={() => getAlertEdit()}>
                                    Editar empresa
                                </button>
                            :
                                <button className={styles.btn} onClick={() => getAlertAdd()}>
                                    Adicionar empresa
                                </button>
                        }
                    </div>
            }
        </div>
    );
}

export default EditarEmpresasCartoes;